import selectors from './selectors'
import slice from './slice'
import thunks from './thunks'

export { slice as newsSlice, selectors as newsSelectors, thunks as newsThunks }
